/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DaypartsDaypartIdMenusMenuIdDelete$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;
  menuId: string;
}

export function daypartsDaypartIdMenusMenuIdDelete(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdMenusMenuIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdMenusMenuIdDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
    rb.path('menuId', params.menuId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

daypartsDaypartIdMenusMenuIdDelete.PATH = '/dayparts/{daypartId}/menus/{menuId}';
